import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-License-Identifier: AGPL-3.0-or-later
import { useId } from 'react';
import { describedBy, FieldHost } from '../FieldHost.js';
import { useLanguage } from '../../i18n/LanguageProvider.js';
import { translateField } from '../../i18n/translate.js';
function asBoolean(v) {
    return typeof v === 'boolean' ? v : undefined;
}
/**
 * Boolean field. Renders as two radios so the unset / yes / no states are
 * each distinguishable — a single checkbox would conflate "no" with "not
 * yet answered" and `required` would never trip.
 *
 * Accessibility: the question text is rendered as a `<legend>` inside the
 * `<fieldset>` (WCAG 1.3.1) so screen readers announce the prompt as the
 * group name when either radio is focused. The wrapping `FieldHost` is
 * given an item with `text: undefined` so it skips its own label render
 * — the legend is the field's accessible name.
 */
export function YesNo(props) {
    const { item, value, errors, disabled, onChange } = props;
    const { lang, t } = useLanguage();
    const groupId = useId();
    const current = asBoolean(value);
    const name = `yesno-${groupId}`;
    const itemWithoutLabel = { ...item, text: undefined };
    return (_jsx(FieldHost, { item: itemWithoutLabel, errors: errors, controlId: groupId, children: (ctx) => (_jsxs("fieldset", { id: groupId, disabled: disabled === true, "data-yes-no": "true", "aria-invalid": ctx.hasError || undefined, "aria-describedby": describedBy(ctx), children: [item.text !== undefined ? (_jsx("legend", { children: translateField(item, 'text', lang, item.text) })) : null, _jsxs("label", { children: [_jsx("input", { type: "radio", name: name, value: "yes", checked: current === true, required: item.required === true, onChange: () => {
                                onChange(true);
                            } }), t('fields.yes')] }), _jsxs("label", { children: [_jsx("input", { type: "radio", name: name, value: "no", checked: current === false, required: item.required === true, onChange: () => {
                                onChange(false);
                            } }), t('fields.no')] })] })) }));
}
//# sourceMappingURL=YesNo.js.map